import React from 'react';
import axios from 'axios';
import { Link, useNavigate, useSearchParams } from "react-router-dom";

import SystemFailed from '../Pages/SystemFailed';

import Logo from '../Components/Logo';
import Loading from '../Components/Loading';

import styles from '../Styles/Auth.module.css';

const Login = () => {
    const navigate = useNavigate();
    const [email, setEmail] = React.useState('');
    const [password, setPassword] = React.useState('');
    const [status, setStatus] = React.useState('');
  
    const [dbStatus, setDbStatus] = React.useState('checking');
    const [loading, setLoading] = React.useState(true);
    const [loadingButton, setLoadingButton] = React.useState(false);

    const [searchParams] = useSearchParams();
    const redirect = searchParams.get('redirect') || '/account';

    React.useEffect(() => {
      const fetchData = async () => {
        try {
            const response = await axios.get('/api/health');
            if (response.status === 200) {
                setDbStatus('connected');
            }
        } catch (err) {
            setDbStatus('Отсутствует подключение к серверу');
        } finally {
            setLoading(false);
        }
    };
  
    fetchData();
    }, []);
  
  
    const handleLogin = async (e) => {
        e.preventDefault();
        setLoadingButton(true);

        axios.post('/api/login', {
            email,
            password
        })
        .then((response) => {
            localStorage.setItem('token', response.data.token);
            navigate(redirect);
        })
        .catch(error => {
            setLoadingButton(false);
            setStatus(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            setTimeout(() => {
                setStatus('');
            }, 4000);
        })
    };

    return (
        <>
        {loading ? (
            <Loading />
        ) : dbStatus === 'connected' ? (
            <>
                <div className={styles.indexMain}>
                    <div className={styles.lining}>
                        <div className={styles.leftSide}>
                            <span>
                                <div style={{width: '100%', display: 'flex', justifyContent: 'space-between'}}>
                                    <Logo to='/' position='relative' />
                                    <Link to='/' className={styles.closeBtnContainerMobile}>
                                        <img src='/img/icons/close-x.svg' alt='X' />
                                    </Link>
                                </div>
                                <h1>Войдите, чтобы пользоваться админ-панелью</h1>
                                <a>Введите адрес электронной почты</a>
                                <input
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Введите e-mail"
                                minLength="3"
                                maxLength="100"
                                required
                                />
                                <a>Введите пароль</a>
                                <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Введите пароль"
                                minLength="4"
                                maxLength="180"
                                required
                                />
                            </span>
                            <span>
                                {status && (
                                    <a className={`${styles.statusPanel} ${styles.red}`}>
                                        <img src="/img/icons/error-icon.svg" alt="Ошибка" />
                                        {status}
                                    </a>
                                )}
                                {loadingButton ? 
                                    <Loading /> 
                                    : 
                                    <button className='button maxWidth' onClick={handleLogin}>Войти</button>
                                }
                            </span>
                        </div>
                        <div className={styles.rightSide}>
                            <Link to='/' className={styles.closeBtnContainer}>
                                <img src='/img/icons/close-x.svg' alt='X' />
                            </Link>
                            <span>
                                <div className={styles.additionalBtn}>
                                    <img src='/img/icons/signin.svg' alt='Вход' />
                                    <span>
                                        <h2>Ещё нет учётной записи?</h2>
                                        <Link to='/auth/registration'>Перейти к странице регистрации</Link>
                                    </span>
                                </div>
                                <div className={styles.additionalBtn}>
                                    <img src='/img/icons/comment-question.svg' alt='Поддержка' />
                                    <span>
                                        <h2>Возникла проблема?</h2>
                                        <a href="tel:89648376494">Позвонить: +7 964 837 64 94</a>
                                    </span>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </>
        ) : (
            <span style={{display: 'flex', flexDirection: 'column', padding: '10px', boxSizing: 'border-box'}}>
                <SystemFailed />
            </span>
        )}
        </>
    )
};

export default Login;
